export enum MessageTypes {
  AlfieInitialized = 'ALFIE_INITIALIZED',
  BpAuth = 'BP_AUTH',
  MiniFlowTaskStarted = 'MINI_FLOW_TASK_STARTED',
  MiniFlowTaskCompleted = 'MINI_FLOW_TASK_COMPLETED',
  MiniFlowConditionRequest = 'MINI_FLOW_CONDITION_REQUEST',
  MiniFlowTaskFailed = 'MINI_FLOW_TASK_FAILED',
}
